export const CHOOSE_SCREEN_HEIGHT = 286

export const FILTER_PANEL_HEIGHT = 227

export const NOTIFICATION_BANNER_HEIGHT = 42

export const NO_DATASETS_ADDITIONAL_HEIGHT = 24
